import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ArticleService } from './article.service';
import { catchError, of } from 'rxjs';

export const recommendationsResolver = (route: ActivatedRouteSnapshot) => {
  const articleService = inject(ArticleService);
  return articleService
    .getRecommendedArticles(route.paramMap.get('id'))
    .pipe(catchError(() => of([])));
};
